import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

export const ToDoTagInfoSchema = z.object({
	id: z.number().optional(),
	name: z.string().min(1, { message: REQUIRED }).trim(),
});

export const ToDoTagResponseSchema = z.array(ToDoTagInfoSchema);

export type ToDoTagInfo = z.infer<typeof ToDoTagInfoSchema>;
